import { Link } from 'react-router-dom'
import LogoBackdrop from '../components/landing/LogoBackdrop'
import './LandingPage.css'

const features = [
  {
    title: 'All codes in one place',
    body: 'Every building code and standard teams rely on — clean, navigable PDFs organized by section.',
  },
  {
    title: 'AI-powered search',
    body: 'Ask questions in plain language and jump straight to the relevant provision across the whole corpus.',
  },
  {
    title: 'Collaborate & comment',
    body: 'Share provisions, align on interpretations, and keep projects moving with your team.',
  },
  {
    title: 'Notes & guides',
    body: 'Capture research in shared notes and attach reusable guides across your work.',
  },
]

const audience = ['Design & Engineering', 'Construction', 'Facilities', 'EHS & Compliance']

function LandingPage() {
  return (
    <div className="landing">
      <section className="landing-hero">
        <LogoBackdrop />
        <div className="landing-hero-overlay" />

        <header className="landing-header">
          <div className="landing-brand">Codetalk</div>
          <nav className="landing-nav">
            <Link className="landing-link" to="/login">
              Log in
            </Link>
            <Link className="landing-btn landing-btn-primary" to="/signup">
              Sign up
            </Link>
          </nav>
        </header>

        <div className="landing-hero-content">
          <h1 className="landing-hero-title">Codes and standards, built for teams.</h1>
          <p className="landing-hero-subtitle">
            CodeTalk is the workspace where teams read, search, and
            collaborate on the building codes and standards behind every site.
          </p>
          <div className="landing-hero-actions">
            <Link className="landing-btn landing-btn-primary" to="/signup">
              Get started
            </Link>
            <Link className="landing-btn landing-btn-ghost" to="/login">
              Log in
            </Link>
          </div>
        </div>
      </section>

      <section className="landing-features">
        {features.map((feature) => (
          <div className="landing-feature" key={feature.title}>
            <h3 className="landing-feature-title">{feature.title}</h3>
            <p className="landing-feature-body">{feature.body}</p>
          </div>
        ))}
      </section>

      <section className="landing-audience">
        <h2 className="landing-audience-title">Built for teams</h2>
        <div className="landing-audience-list">
          {audience.map((item) => (
            <span className="landing-audience-item" key={item}>
              {item}
            </span>
          ))}
        </div>
      </section>

      <footer className="landing-footer">
        <span>CodeTalk</span>
        <span>&copy; {new Date().getFullYear()}</span>
      </footer>
    </div>
  )
}

export default LandingPage
